import AxiosNode from '@/services/api/node/axios_node'

export default {
  getAutomationTriggers: () => {
    return AxiosNode.get('/automation/triggers')
  },

  getAllAutomations: (data) => {
    return AxiosNode.get('/automation', {params: data})
  },

  createAutomation: (data) => {
    return AxiosNode.post('automation', data)
  },

  updateAutomation: (data, id) => {
    return AxiosNode.put('automation/' + id, data)
  },

  deleteAutomation: (id) => {
    return AxiosNode.delete('automation/' + id)
  },

  getAutomationsByNode: (nodeId) => {
    return AxiosNode.get('automation/node/' + nodeId)
  },  

  getAutomation: (id) => {
    return AxiosNode.get('/automation/' + id)
  },
}
